/**
 * Query strings in one order, for a key: the same searches give the same list, whatever the order
 * in which a caller built them. The parameters of each query go in order of name; a sort is
 * stable, so repeated parameters keep their order, which a server can read as meaningful.
 */
export function getCanonicalQueries(queries: readonly string[]): string[] {
    return queries
        .map((query): string => {
            const params = new URLSearchParams(query);
            params.sort();
            return params.toString();
        })
        .sort();
}
